import { render, staticRenderFns } from "./bidingDoc.vue?vue&type=template&id=b84d52d6&scoped=true&"
import script from "./bidingDoc.vue?vue&type=script&lang=js&"
export * from "./bidingDoc.vue?vue&type=script&lang=js&"
import style0 from "./bidingDoc.vue?vue&type=style&index=0&id=b84d52d6&prod&scoped=true&lang=css&"
import style1 from "./bidingDoc.vue?vue&type=style&index=1&id=b84d52d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84d52d6",
  null
  
)

export default component.exports